import SectionTitle from "@/components/base/SectionTitle";
import AdvisorFicha from "@/pages/asesor/components/AdvisorFicha";

// Mi Cuenta: la ficha personal del asesor (ventas, tenencia, deuda y margen).
const AsesorCuentaPage = () => (
  <div className="pb-24">
    <SectionTitle
      text="Mi Cuenta"
      subtitle="Tus ventas realizadas, tu mercancía en tenencia, lo que debes y tu margen de ganancia, todo en un solo lugar."
    />
    <AdvisorFicha />
  </div>
);

export default AsesorCuentaPage;